import React, { useEffect } from 'react';
import Hero from '../../components/sections/Hero';
import Overview from '../../components/sections/Overview';
import Services from '../../components/sections/Services';
import Process from '../../components/sections/Process';
import Technologies from '../../components/sections/Technologies';
import Gallery from '../../components/sections/Gallery';
import Cta from '../../components/sections/Cta';
import { setupScrollAnimations } from '../../utils/animations';
import { strategyPageData } from '../../data/strategyPageData';

const StrategyPage = () => {
  useEffect(() => {
    const observer = setupScrollAnimations();
    return () => observer.disconnect();
  }, []);

  return (
    <div>
      <Hero
        variant="biHero"
        title={strategyPageData.hero.title}
        description={strategyPageData.hero.description}
      />
      <Overview data={strategyPageData.overview} />
      <Services data={strategyPageData.services} />
      <Process data={strategyPageData.process} />
      <Technologies data={strategyPageData.technologies} />
      <Gallery data={strategyPageData.gallery} />
      <Cta data={strategyPageData.cta} />
    </div>
  );
};

export default StrategyPage;


